import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorMessagesDirective } from './shared/directives/error-messages.directive';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { environment } from 'src/environments/environment';
import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';
import { MainModule } from './main/main.module';
import { AuthModule } from './auth/auth.module';
import { UserResolver } from './auth/user.resolver';

@NgModule({
  declarations: [
    AppComponent,
    ConfirmDialogComponent,
    ErrorMessagesDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,

    // Firebase Modules
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    AngularFireDatabaseModule,

    // Routes and Guard
    AuthModule,
    AppRoutingModule,
  ],
  providers: [UserResolver],
  bootstrap: [AppComponent]
})
export class AppModule { }
